import { render, staticRenderFns } from "./LeagueSeasons.vue?vue&type=template&id=5278d7a8"
import script from "./LeagueSeasons.vue?vue&type=script&lang=js"
export * from "./LeagueSeasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports